import React, { useEffect, useState } from 'react';
import { pexelsService } from '../../../services';

export default function MediaPickerModal({
  open,
  type,
  onClose,
  onSelectImage,
  onSelectVideo,
}) {
  const [query, setQuery] = useState('marketing');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open) return;
    const run = async () => {
      setLoading(true);
      setError('');
      const service = type === 'video' ? pexelsService.searchVideos : pexelsService.searchImages;
      const result = await service({ q: query, page: 1 });

      if (!result?.success) {
        setItems([]);
        setError(result?.message || (type === 'video' ? 'Não foi possível carregar vídeos' : 'Não foi possível carregar imagens'));
      } else {
        setItems(result.items || []);
      }
      setLoading(false);
    };

    run();
  }, [open, query, type]);

  if (!open) return null;

  return (
    <div className="manual-modal" role="dialog" aria-modal="true" aria-label="Selecionar mídia Pexels">
      <div className="manual-modal__card">
        <header className="manual-modal__header">
          <h3>{type === 'video' ? 'Vídeos Pexels' : 'Imagens Pexels'}</h3>
          <button type="button" className="manual-modal__close" onClick={onClose}>Fechar</button>
        </header>

        <div className="manual-modal__search">
          <input
            type="text"
            value={query}
            onChange={(event) => setQuery(event.target.value)}
            placeholder={type === 'video' ? 'Buscar vídeos...' : 'Buscar imagens...'}
          />
        </div>

        <div className="manual-modal__grid">
          {loading && <p>Carregando...</p>}
          {!loading && error && <p>{error}</p>}
          {!loading && !error && items.map((item) => {
            const thumb = item.thumb || item.small || item.medium || item.large;
            const videoLink = item.video_files?.[0]?.link || '';

            return (
              <button
                key={`${type}-${item.id}`}
                type="button"
                className="manual-modal__item"
                onClick={() => {
                  if (type === 'video') onSelectVideo(videoLink);
                  else onSelectImage(item.large || item.original || item.medium || thumb);
                  onClose();
                }}
              >
                <img src={thumb} alt={item.author || 'Mídia'} loading="lazy" />
                <span>{item.author || 'Pexels'}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
